import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { connect } from "react-redux";
import {
  getInvestorDetails,
  checkKyc,
  userPan,
  storeKYCData,
  clearingFirstTimeInvestorJourney,
} from "../../store/actions";
import { REQ_BY } from "../../store/types";
import { INVESTOR_URL } from "./investors";
import { NEW_TRANSACTION_URL } from "./transactions";
import { MAILBACK_URL } from "./mailBackRequest";
import { HISTORY_URL } from "./transactionHistory";
import Image from "../Image";
import CustomLoader from "../forms/Loader";
import { getCartCount, getCartItemsList } from "../../store/actions/cart";

class TableData extends Component {
  constructor(props) {
    super(props);
    this.state = { count: [] };
  }

  goToTransaction = (PAN, name, mailBackName) => async () => {
    await this.props.userPan(PAN);
    await this.props.storeKYCData({});
    await this.props.clearingFirstTimeInvestorJourney();
    const response = await this.getInvestorDetails(PAN);
    if (response) {
      this.props.history.push({
        pathname: NEW_TRANSACTION_URL + "/transction-types",
      });
    } else {
      const kycResponse = await this.getKycDetails(PAN);
      if (kycResponse) {
        const {
          DtData: [info],
        } = kycResponse;
        if (info.KYCBlock === "N") {
          this.props.history.push({
            pathname: NEW_TRANSACTION_URL + "/transction-types",
          });
        }
      }
    }
  };

  async componentDidMount() {
    try {
      const response = await this.props.getCartCount(this.props.token);
      !!response?.length && this.setState({ count: response });
    } catch (e) {
      console.error(e);
    }
  }

  getInvestorDetails = async (pan) => {
    const params = { PAN: pan, Uid: this.props.userId, ReqBy: REQ_BY };
    const response = await this.props.getInvestorDetails(params);
    return response;
  };

  getKycDetails = async (pan) => {
    const params = {
      i_pan: pan,
      fund: "",
      userid: this.props.userId,
    };
    const kycResponse = await this.props.checkKyc(params);
    return kycResponse;
  };

  goToMailBack = (PAN, mailBackName) => async () => {
    const response = await this.getInvestorDetails(PAN);
    if (response) {
      if (mailBackName === "mailBackSoa") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/mail-back-soa",
        });
      } else if (mailBackName === "ELSS") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/ELSS",
        });
      } else if (mailBackName === "CAN") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/CAN",
        });
      } else if (mailBackName === "CGS") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/CGS",
        });
      } else if (mailBackName === "CCGS") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/CCGS",
        });
      } else if (mailBackName === "GAS") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/GAS",
        });
      } else if (mailBackName === "Networth") {
        this.props.history.push({
          pathname: MAILBACK_URL + "/investor/investor-selection/Networth",
        });
      } else {
        this.props.history.push({
          pathname:
            MAILBACK_URL +
            "/investor/investor-selection/consolidated-account-statement",
        });
      }
    } else {
      const kycResponse = await this.getKycDetails(PAN);
      const {
        DtData: [info],
      } = kycResponse;
      if (info.KYCBlock === "N") {
        if (mailBackName === "mailBackSoa") {
          this.props.history.push({
            pathname:
              MAILBACK_URL + "/investor/investor-selection/mail-back-soa",
          });
        } else if (mailBackName === "ELSS") {
          this.props.history.push({
            pathname: MAILBACK_URL + "/investor/investor-selection/ELSS",
          });
        } else if (mailBackName === "CAN") {
          this.props.history.push({
            pathname: MAILBACK_URL + "/investor/investor-selection/CAN",
          });
        } else {
          this.props.history.push({
            pathname:
              MAILBACK_URL +
              "/investor/investor-selection/consolidated-account-statement",
          });
        }
      }
    }
  };

  goToTransactionHistory = (PAN) => async () => {
    const response = await this.getInvestorDetails(PAN);
    if (response) {
      this.props.history.push({
        pathname: `${HISTORY_URL}/details/xxxxxxxxxxx`,
        state: { isKyc: true },
      });
    } else {
      const kycResponse = await this.getKycDetails(PAN);
      const {
        DtData: [info],
      } = kycResponse;
      if (info.KYCBlock === "N") {
        this.props.history.push({
          pathname: `${HISTORY_URL}/details/xxxxxxxxxxx`,
          state: { isKyc: false },
        });
      }
    }
  };

  goToCart = async (pan) => {
    this.props.history.push({
      pathname: "/cart/investor-cart",
      state: { pan },
    });
  };

  render() {
    const pathname = this.props.location.pathname;
    const { investors, count } = this.props;
    return (
      <div className="investor_table_sec">
        {count > 0 ? (
          <CustomLoader display={true} />
        ) : !investors?.length ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "OPenSans-SemiBold",
            }}
          >
            No data Found
          </div>
        ) : (
          ((this.props.tran_enable_flag === "Y" &&
            investors.length !== this.props.investorsCount) ||
            this.props.tran_enable_flag === "N") && (
            <React.Fragment>
              <Paper className="investors-paper">
                <Table>
                  <TableBody>
                    {investors.map((investor, index) => {
                      const cartCount = this.state.count.find((inv) => {
                        return (
                          String(inv.PAN).toUpperCase().trim() ===
                            String(investor.Pan).toUpperCase().trim() &&
                          !!inv.PAN &&
                          !!investor.Pan
                        );
                      })?.count;
                      return (
                        <TableRow key={index}>
                          <TableCell className="table-cell">
                            <Image
                              src={"/images/user.png"}
                              alt="user"
                              className="user-icon"
                            />
                            {pathname.includes("/new-transaction") ||
                            pathname.includes("/mailBackRequest") ||
                            pathname.includes("/transaction-history") ? (
                              <span
                                className="investor-name"
                                style={{ fontFamily: "OpenSans-SemiBold" }}
                              >
                                {investor.Name}
                              </span>
                            ) : (
                              <span
                                className="mouse-pointer"
                                onClick={() =>
                                  this.props.history.push({
                                    pathname: `${INVESTOR_URL}/details/xxxxxxxxxx`,
                                    state: `${investor.Pan}`,
                                  })
                                }
                                style={{
                                  borderBottom: "2px solid #80bce3",
                                  paddingBottom: 3,
                                  fontFamily: "OpenSans-SemiBold",
                                }}
                              >
                                {investor.Name}
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="table-cell">
                            <span className="kyc-fafc-verification">
                              <Image
                                src={
                                  !!investor.Kyc
                                    ? "/images/checkmark_investors.svg"
                                    : "/images/cross_investors.svg"
                                }
                                alt={
                                  !!investor.Kyc
                                    ? "kyc-complete"
                                    : "kyc-incomplete"
                                }
                                className="verified-icon"
                              />
                              <span className="verfication-text">KYC</span>
                              <Image
                                src={
                                  !!investor.Fatca
                                    ? "/images/checkmark_investors.svg"
                                    : "/images/cross_investors.svg"
                                }
                                className="verified-icon"
                                alt={
                                  !!investor.Fatca
                                    ? "fatca-complete"
                                    : "fatca-incomplete"
                                }
                              />
                              <span className="verfication-text">FATCA</span>
                              <Image
                                src={
                                  !!investor.KOTM
                                    ? "/images/checkmark_investors.svg"
                                    : "/images/cross_investors.svg"
                                }
                                className="verified-icon"
                                alt={
                                  !!investor.KOTM
                                    ? "fatca-complete"
                                    : "fatca-incomplete"
                                }
                              />
                              <span className="verfication-text">KOTM</span>
                            </span>
                          </TableCell>
                          <TableCell className="table-cell">
                            <Image
                              src={"/images/call_investors.svg"}
                              alt="phone-icon"
                              className="phone-icon"
                            />
                            {investor.Mobile}
                          </TableCell>
                          <TableCell className="table-cell">
                            PAN : {investor.Pan}
                          </TableCell>

                          <TableCell
                            className="table-cell"
                            aria-disabled={true}
                          >
                            <div
                              className="mouse-pointer"
                              style={{
                                display:
                                  (!!investor.Pan &&
                                    investor.Pan.charAt(3).toUpperCase() ===
                                      "P") ||
                                  investor.Pan.charAt(3).toUpperCase() === "H"
                                    ? "block"
                                    : "none",
                              }}
                              onClick={
                                pathname.includes("/transaction-history")
                                  ? this.goToTransactionHistory(investor.Pan)
                                  : pathname.includes(
                                      "/mailBackRequest/investor/investor-selection"
                                    )
                                  ? this.goToMailBack(
                                      investor.Pan,
                                      this.props.location.state.name
                                    )
                                  : this.goToTransaction(investor.Pan)
                              }
                            >
                              {pathname.includes("/investors") ||
                              pathname.includes("/transaction-history") ? (
                                <span className="transaction-button">
                                  {pathname.includes("/investors") && (
                                    <Image
                                      src={"/images/rupees_white.png"}
                                      className="transction-action-icon"
                                      alt="rupees-icon"
                                    />
                                  )}
                                  {pathname.includes("/investors")
                                    ? "New Transaction"
                                    : "View Transactions"}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    border: "1px solid #007ac8",
                                    padding: "5px 25px 7px 25px",
                                    color: "#007ac8",
                                    borderRadius: 3,
                                  }}
                                >
                                  New&nbsp;Transaction
                                </span>
                              )}
                            </div>
                          </TableCell>

                          {!pathname.includes("/transaction-history") &&
                            cartCount && (
                              <TableCell className="table-cell">
                                <div
                                  onClick={() => this.goToCart(investor.Pan)}
                                  style={{
                                    position: "relative",
                                    marginRight: 5,
                                    cursor: "pointer",
                                    width: 25,
                                  }}
                                >
                                  <Image
                                    src="/images/cart.png"
                                    style={{ width: 25 }}
                                  />
                                  <span className="cart-count">
                                    {cartCount}
                                  </span>
                                </div>
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Paper>
              <div className="investor-blocks">
                {investors.map((investor, index) => {
                  const cartCount = this.state.count.find((inv) => {
                    return (
                      String(inv.PAN).toUpperCase().trim() ===
                        String(investor.Pan).toUpperCase().trim() &&
                      !!inv.PAN &&
                      !!investor.Pan
                    );
                  })?.count;
                  const displayCart = !!cartCount;
                  return (
                    <Paper
                      className="investor-blocks-paper"
                      style={{
                        boxShadow: "0px 0px 3px 0px rgba(211,211,211,0.8)",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexGrow: 1,
                            flexBasis: 0,
                          }}
                        >
                          <Image
                            src={"/images/user.png"}
                            alt="user"
                            className="user-block-icon"
                          />
                          {pathname.includes("/new-transaction") ||
                          pathname.includes("/mailBackRequest") ||
                          pathname.includes("/transaction-history") ? (
                            <span className="investor-name">
                              {investor.Name}
                            </span>
                          ) : (
                            <span
                              className="mouse-pointer"
                              onClick={() =>
                                this.props.history.push({
                                  pathname: `${INVESTOR_URL}/details/xxxxxxxxxx`,
                                  state: `${investor.Pan}`,
                                })
                              }
                              style={{
                                borderBottom: "2px solid #80bce3",
                                paddingBottom: 3,
                                fontFamily: "SourceSansPro-SemiBold",
                              }}
                            >
                              {investor.Name}
                            </span>
                          )}
                        </div>
                        <div
                          onClick={
                            pathname.includes("/transaction-history")
                              ? this.goToTransactionHistory(investor.Pan)
                              : pathname.includes(
                                  "/mailBackRequest/investor/investor-selection"
                                )
                              ? this.goToMailBack(
                                  investor.Pan,
                                  this.props.location.state.name
                                )
                              : this.goToTransaction(investor.Pan)
                          }
                        >
                          <div
                            className="mouse-pointer "
                            style={{
                              display:
                                (!!investor.Pan &&
                                  investor.Pan.charAt(3).toUpperCase() ===
                                    "P") ||
                                investor.Pan.charAt(3).toUpperCase() === "H"
                                  ? "block"
                                  : "none",
                              alignItems: "center",
                              // minWidth: 180,
                            }}
                          >
                            {pathname.includes("/investors") ||
                            pathname.includes("/transaction-history") ? (
                              <span className="transaction-button">
                                {pathname.includes("/investors") && (
                                  <Image
                                    src={"/images/rupees_white.png"}
                                    className="transction-action-icon"
                                    alt="rupees-icon"
                                  />
                                )}
                                {pathname.includes("/investors")
                                  ? "New Transaction"
                                  : "View Transactions"}
                              </span>
                            ) : (
                              <div
                                className="row"
                                style={{ marginRight: 4, alignItems: "center" }}
                              >
                                <span
                                  style={{
                                    border: "1px solid #007ac8",
                                    padding: "5px 8px",
                                    // padding: "5px 25px 7px 25px",
                                    color: "#007ac8",
                                    borderRadius: 3,
                                  }}
                                >
                                  New&nbsp;Transaction
                                </span>

                                {displayCart && (
                                  <div
                                    style={{
                                      position: "relative",
                                      marginLeft: 10,
                                      marginRight: 8,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => this.goToCart(investor.Pan)}
                                  >
                                    <Image
                                      src="/images/cart.png"
                                      style={{ width: 21 }}
                                    />

                                    <span className="cart-count">
                                      {cartCount}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 20,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexGrow: 1,
                            flexBasis: 0,
                          }}
                        >
                          <span className="kyc-fafc-verification">
                            <Image
                              src={
                                !!investor.Kyc
                                  ? "/images/checkmark_investors.svg"
                                  : "/images/cross_investors.svg"
                              }
                              alt={
                                !!investor.Kyc
                                  ? "kyc-complete"
                                  : "kyc-incomplete"
                              }
                              className="verified-icon"
                            />
                            <span className="verfication-text">KYC</span>
                            <Image
                              src={
                                !!investor.Fatca
                                  ? "/images/checkmark_investors.svg"
                                  : "/images/cross_investors.svg"
                              }
                              className="verified-icon"
                              alt={
                                !!investor.Fatca
                                  ? "fatca-complete"
                                  : "fatca-incomplete"
                              }
                            />
                            <span className="verfication-text">FATCA</span>
                            <Image
                              src={
                                !!investor.KOTM
                                  ? "/images/checkmark_investors.svg"
                                  : "/images/cross_investors.svg"
                              }
                              className="verified-icon"
                              alt={
                                !!investor.KOTM
                                  ? "fatca-complete"
                                  : "fatca-incomplete"
                              }
                            />
                            <span className="verfication-text">KOTM</span>
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                            flexBasis: 0,
                          }}
                        >
                          <div>
                            <Image
                              src={"/images/call_investors.svg"}
                              alt="phone-icon"
                              className="phone-icon"
                            />
                          </div>
                          <div className="fontCommon">{investor.Mobile}</div>
                        </div>
                        <div
                          style={{
                            flexGrow: 1,
                            flexBasis: 0,
                            display: "flex",
                            justifyContent: "center",
                          }}
                          className="fontCommon"
                        >
                          <span className="span-calss">PAN :</span>
                          {investor.Pan}
                        </div>
                      </div>
                    </Paper>
                  );
                })}
              </div>
            </React.Fragment>
          )
        )}
      </div>
    );
  }
}

export default connect(
  ({ investor, authReducer, loading }) => {
    const { userId, token, tran_enable_flag, isCartUser } = authReducer;
    const { investors, loaderDisplay, count: investorsCount } = investor;
    const { count } = loading;
    return {
      investors,
      isCartUser,
      userId,
      token,
      loaderDisplay,
      count,
      tran_enable_flag,
      investorsCount,
    };
  },
  {
    getInvestorDetails,
    checkKyc,
    getCartCount,
    getCartItemsList,
    userPan,
    storeKYCData,
    clearingFirstTimeInvestorJourney,
  }
)(TableData);
